import { useRouteError } from 'react-router';

import ErrorFallback from '@components/TopLevelBlockingErrorBoundary/ErrorFallback';

export default function RouterErrorFallback() {
  const error = useRouteError();

  return (
    <ErrorFallback
      error={error}
      resetErrorBoundary={() => {
        // Stay on the current deep link (e.g. /newlists/:id). Reloading clears
        // the route error boundary without dumping the user on Home.
        window.location.reload();
      }}
    />
  );
}
